export default "__VITE_ASSET__87YlAmZd__"